var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode-link"},[_c('button',{on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":require("./images/qrcode.png")}})]),_c('span',{staticClass:"qrcode-link__tip"},[_vm._v("扫码登录更安全")])])
}
var staticRenderFns = []

export { render, staticRenderFns }